﻿/**
 * search-result.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('search-result.controller', searchResultController);

	/** setup injection */
	searchResultController.$inject = ['appSettings'];

	/** implementation */
	function searchResultController(appSettings) {
		/** pubic properties */
		var vm = this;
		vm.studentUrl = '';
		vm.staffUrl = '';
		vm.parentUrl = '';

		/** public methods */
		vm.adjustStudentUrl = adjustStudentUrl;

		/** run init */
		init();

		/** public method implementations */

		/** adjust the student url */
		function adjustStudentUrl(url, id) {
			return url.replace('{id}', id);
		}

		/** private methods */

		/** initialize */
		function init() {
			/** set urls */
			vm.studentUrl = appSettings.studentManagementWebRootUrl + '{id}/demographics/information';
			vm.staffUrl = appSettings.staffManagementWebRootUrl + 'staff-record/' + vm.result.staffID;
			vm.parentUrl = appSettings.studentManagementWebRootUrl + 'guardian/' + vm.result.guardianID + '/' + vm.academicYearId + '/' + vm.schoolId + '/guardian/overview';

			/** check for student and adjust */
			if (vm.type === 'student') {
				vm.studentUrl = adjustStudentUrl(vm.studentUrl, vm.result.studentInSchoolID);
			}
		}
	}
})();